import { FormControl } from '@angular/forms';
import { GrocyBasics } from '../../../../core/entities/grocy/shared/basics.entity';
import { positiveNotNull, positiveOrZero, requiredNotNull } from '../../../../forms/form-control-options.constants';
import { BaseFormControls } from '../../../../forms/form-controls/base.form-controls';

export class GrocyDashboardShoppingItemFormControls extends BaseFormControls {
  amount = new FormControl(1, positiveNotNull);
  bestBeforeDate = new FormControl<Date | null>(new Date());
  location = new FormControl<GrocyBasics | null>(null, requiredNotNull);
  neverOverdue = new FormControl(true, requiredNotNull);
  pantIncluded = new FormControl(false, requiredNotNull);
  purchaseQuPant = new FormControl<number | null>(null, positiveOrZero);
  purchaseQuPrice = new FormControl<number | null>(null, positiveOrZero);
  totalDiscount = new FormControl<number | null>(null, positiveOrZero);
}
